import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chargers',
  templateUrl: './chargers.component.html',
  styleUrls: ['./chargers.component.css']
})
export class ChargersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
